import React from 'react';
import { List, Pagination } from 'react-admin';
import { AVATAR_TRACEABILITY_NOTES } from '../../providers/resources';
import { extractIdFromURI } from '../../utils/resources/ids';
import { NotesFilters, NotesListBody } from '../notes';
import { Box } from '@material-ui/core';
import './RightNotesTab.css';

interface RightNotesTabProps {
    selected: any;
}

const RightNotesTab: React.FC<RightNotesTabProps> = ({ selected }) => {
    // En la vista de boards (ancs_every_2_hours) el record trae `avatarId` (el id
    // del avatar real); su `id` es el del board. En la vista normal de avatares no
    // hay `avatarId`, así que se usa `id`/`@id`.
    const selectedId: string | undefined = selected?.avatarId || selected?.id || selected?.['@id'];

    return (
        <Box className='note-list'>
            <List
                component='div'
                resource={AVATAR_TRACEABILITY_NOTES}
                basePath={`/${AVATAR_TRACEABILITY_NOTES}`}
                filter={{ avatarId: selectedId ? extractIdFromURI(selectedId) : undefined }}
                sort={{
                    field: 'createdAt',
                    order: 'DESC',
                }}
                pagination={<Pagination />}
                bulkActionButtons={false}
                actions={false}
                empty={false}
                filters={<NotesFilters />}
            >
                <NotesListBody />
            </List>
        </Box>
    );
};

export default RightNotesTab;
